import { ElementType, ReactNode, useEffect, useState } from 'react';
import Head from 'next/head';
import cn from 'classnames';
import { useRouter } from 'next/router';
import PageSeo from '@framework/seo/PageSeo';
import config from '@finsight/config';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import Footer from '@/finsight/ui/common/components/Footer';
import ContentWrp from '@framework/ui/Templates/ContentWrp';
import { staticPaths } from '@finsight/urls/static';
import StaticPagesContextProvider from '@/finsight/ui/components/staticPages/StaticTemplate/StaticPagesContext';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import { IFooter } from '@/finsight/domain/vo/IFooter';
import { CONTENT_WRAPPER_ID } from './constants';

import styles from './Layout.module.scss';
import stickyFooterStyles from '@framework/ui/Organisms/StickyFooter/stickyFooter.module.scss';

interface ILayoutProps {
  children: ReactNode,
  HeaderComponent: ElementType,
  footerConfig?: IFooter,
  className?: string,
}
const Layout = ({
  children,
  HeaderComponent,
  footerConfig,
  className,
}: ILayoutProps) => {
  const [isOnStaticPage, setIsOnStaticPage] = useState(false);
  const { pathname, asPath } = useRouter();

  useEffect(() => {
    const isStaticPage = staticPaths.getStaticPagesList().indexOf(pathname) !== -1;
    if (isStaticPage) {
      setIsOnStaticPage(true);
      return;
    }
    setIsOnStaticPage(false);
  }, [pathname]);

  return (
    <>
      { !isOnStaticPage && (<PageSeo />) }
      <Head>
        <link rel="canonical" href={ finsightWebUrl.getUrl(asPath) } />
      </Head>
      <ScrollBodyBackground tenant={ config.code } />
      <ContentWrp className={ cn(styles.contentWrpOverflowFix, className) }>
        <StaticPagesContextProvider>
          <div
            className={ cn(
                styles.headerAndContentHolder,
                stickyFooterStyles.pageContainerWithStickyFooter,
                stickyFooterStyles.isSmall,
                {
                  [styles.homePageContainer]: pathname === staticPaths.getBasePath(),
                },
              ) }
          >
            <HeaderComponent />
            <div
              className={ styles.layoutChildrenContainer }
              id={ CONTENT_WRAPPER_ID }
            >
              { children }
            </div>
          </div>
          <Footer config={ footerConfig } />
        </StaticPagesContextProvider>
      </ContentWrp>
    </>
  );
};

export default Layout;
